const TOKEN_FORMAT: string = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

/**
 * Generate a unique UUID token (logic taken from legacy code)
 */
export function uuidGenerate(): string {
  let d = new Date().getTime();

  // Use high-precision timer if available
  if (performance && typeof performance.now === 'function') {
    d += performance.now();
  }

  /* tslint:disable:no-bitwise */
  const uuid = TOKEN_FORMAT.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);

    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  /* tslint:enable:no-bitwise */

  return uuid;
}
